import apiSferest from './apiSferest/index'
import config from '@/utils/config'

export const checkTercero = (nif, receptorNif) => {
    return apiSferest.post(config.tercerosCheckEndpoint, { nif, receptorNif }).then(response => {
        return response.data
    })
}
